module.exports = __webpack_public_path__ + "media/images/Mountain-48f999c4.svg";